/** The contextual first task: Denker looks at the user's work, proposes a
 *  task, hands it off and opens the workspace. Includes spoken lines. */
export default {
  quickHello: "A quick hello.",
  openingLine: "Let me see what I can help you with.",
  guideOpeningLine:
    "Great, let me show you the basics while I check how I can help.",
  gettingConversationReady: "Getting your first conversation ready…",
  next: "Next",
  handoffDone: "Your task is done. Let me show you the basics.",
  handoffInReview:
    "Your task is ready for review. You can find it in your workspace. Let me show you the basics.",
  handoffStarted:
    "Your task has started. I’ll let you know when it’s ready. Let me show you the basics.",
  firstTaskDone: "Your first task is done.",
  continueGettingStarted: "Continue getting started",
  firstTask: "Your first task",
  startingApprovedTask: "Starting the task you approved…",
  taskStatusBacklog: "backlog",
  taskStatusTodo: "todo",
  taskStatusInProgress: "in progress",
  taskStatusInReview: "ready for review",
  taskStatusDone: "done",
  taskStatusBlocked: "blocked",
  showMeTheBasics: "Show me the basics",
  tasksStayInWorkspace: "Your tasks stay in your workspace.",
  noTaskStarted:
    "No task has started. You can finish setup and continue in your workspace.",
  learnBasicsNow: "Now learn the basics and try Denker yourself.",
  taskStaysInWorkspace:
    "Your task stays in your workspace. You can continue with the basics.",
  continueWithBasics:
    "You can continue with the basics and try Denker yourself.",
  openYourPanel: "Open your panel.",
  retryOpenPanel: "Try opening the panel again",
  codingAppFailed:
    "The coding app couldn’t open. Try opening the session again.",
  returnToProjectForTasks: "Return to the original project to see its tasks.",
  taskboardOpenFailed: "Your taskboard couldn’t open. Please try again.",
  proposalTaskboardFailed:
    "Your taskboard couldn’t open. It will be in your workspace.",
  workspaceCouldNotOpen: "Your workspace couldn’t open.",
  pleaseTryAgain: "Please try again.",
  viewTasks: "View tasks",
  openCodingSession: "Open coding session",
  lookAgain: "Look again",
  notConnectedYet: "Denker isn’t connected yet. Try again or see the basics.",
  requestNotAccepted:
    "This request wasn’t accepted. Try again or see the basics.",
  startLookingFailed:
    "I couldn’t start looking at your work. Try again or see the basics.",
  recoverConversationFailed:
    "I couldn’t recover this conversation. Try again or see the basics.",
  answerNotDelivered:
    "Your answer was saved, but it hasn’t reached Denker. Open the question’s delivery controls or see the basics.",
  requestStopped: "This request stopped. You can still see the basics.",
  finishedWithoutReply: "Denker finished without a reply. Try looking again.",
  inspectingTakesLong:
    "Inspecting your work is taking longer than expected. You can try looking again.",
  replyNotDelivered: "Your answer wasn’t delivered. Please try again.",
  onboardingSaveFailed:
    "Onboarding couldn’t finish saving. Try again to start looking at your work.",
  setupStillSaving: "Your setup is still saving. Try again or see the basics.",
  workspaceLoadFailed:
    "Your workspace couldn’t load. Try again or see the basics.",
  connectFailed: "Denker couldn’t connect. Try again or see the basics.",
  coworkerLoadFailed:
    "Your coworker couldn’t load. Try again or see the basics.",
  chooseProjectForWorkspace: "Choose a project to open your workspace.",
  returnToOnboardingProject:
    "Return to the project where you started onboarding to open its workspace.",
  workspaceOpenFailed: "Your workspace could not be opened. Try again.",
  workspaceDisplayFailed: "Your workspace could not be displayed. Try again.",
  memoryVerifyFailed:
    "Your onboarding context could not be verified in memory. Try again.",
  setupSaveFailed: "Your setup couldn’t be saved. Please try again.",
  setupChanged: "Your setup changed. Please try again.",
  runtimeConnectedRetry:
    "{runtime} is connected. Try again to prepare your first conversation, or click Next to see the basics.",
  conversationChanged: "The selected conversation changed. Please try again.",
  runtimeStartFailed: "Couldn’t start {runtime} — try again.",
  runtimePreparationUnfinished:
    "{runtime} is connected, but preparation did not finish. Try again, or click Next to see the basics.",
  taskBoardFrameTitle: "Task Board",
  memoryFrameTitle: "Memory",
  onboardingMemoryName: "Denker onboarding · {date}",
} as const;
